/**
 * Csv Schema of Responsavel
 * @author Simpli CLI generator
 */
import {$, Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {Endereco} from '@/model/resource/Endereco'
import {TipoCliente} from '@/enums/TipoCliente'

/* TODO: review generated schema */
export class CsvResponsavelSchema extends Schema {
  readonly name = 'CsvResponsavel'

  readonly fieldSet: FieldSet<Responsavel> = {
    idResponsavelPk: schema => schema.model.idResponsavelPk,
    cnpj: schema => Helper.cnpj(schema.model.cnpj),
    razaoSocial: schema => schema.model.razaoSocial,
    nomeFantasia: schema => schema.model.nomeFantasia,
    nomeContato: schema => schema.model.nomeContato,
    telefone: schema => Helper.phone(schema.model.telefone),
    email: schema => schema.model.email,
    endereco: schema =>
      schema.model.endereco && Endereco.stringfied(schema.model.endereco),
    dataVencimento: schema => Helper.datetime(schema.model.dataVencimento),
    clienteBloqueado: schema => Helper.bool(schema.model.clienteBloqueado),
    usaGrupoEconomico: schema => Helper.bool(schema.model.usaGrupoEconomico),
    liberarApi: schema => Helper.bool(schema.model.liberarApi),
    urlLogoEmpresa: schema => Helper.bool(!!schema.model.urlLogoEmpresa),
    usaIntegracao: schema => Helper.bool(schema.model.usaIntegracao),
    integracaoTMS: schema =>
      schema.model.usaIntegracao && schema.model.integracaoTMS
        ? schema.model.integracaoTMS
        : '',
    tipoCliente: schema =>
      schema.model.tipoCliente?.nome ??
      ($.t('schema.CsvResponsavel.cliente') as string),
    tipoClienteParceiroNome: schema =>
      schema.model.tipoCliente?.idTipoClientePk == TipoCliente.Parceiro
        ? schema.model.parceiroNome
        : '',
    acessoIlimitadoTransportadores: schema =>
      Helper.bool(schema.model.acessoIlimitadoTransportadores),
    clientePossuiTorreDeControle: schema =>
      Helper.bool(schema.model.clientePossuiTorreDeControle),
    nomeResponsavelTorreDeControle: schema =>
      schema.model.clientePossuiTorreDeControle
        ? schema.model.nomeResponsavelTorreDeControle
        : '',
    nomeResponsavelCadastroUltimaModificacao: schema =>
      schema.model.nomeResponsavelCadastroUltimaModificacao,
    dataUltimaModificacao: schema =>
      Helper.datetime(schema.model.dataUltimaModificacao),
    temGrupoParceiro: schema => Helper.bool(schema.model.temGrupoParceiro),
    idQuemCadastrou: schema => schema.model.idQuemCadastrou || '-',
    quemCadastrou: schema =>
      schema.model.idQuemCadastrou ? schema.model.quemCadastrou : '-',
    tipoCriador: schema => schema.model.nomeTipoCriador as string,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
  }
}
